<template>
	<v-card :flat="!model" height="100%" :class="!model ? 'grey lighten-5' : ''">
		<v-card-title class="pb-0">
			<span v-if="!model">Новый проект</span>
			<v-text-field v-else label="Название" counter="100" v-model.lazy="projectModel.title" :error-messages="titleInputErrors" @keyup.enter="validateForm"></v-text-field>
		</v-card-title>
		<v-card-text style="overflow:hidden" :style="{ height:`${formHeight}px`}">
			<v-text-field label="Название" counter="100" :error-messages="titleInputErrors" v-model="projectModel.title" v-if="!model" @keyup.enter="validateForm"></v-text-field>
			<v-textarea label="Описание" counter="400" v-model.lazy="projectModel.description" no-resize rows="3"></v-textarea>
		</v-card-text>
		<v-card-actions>
			<v-spacer></v-spacer>
			<v-btn color="blue lighten-1" class="mt-1" :dark="projectModel.title.length > 0" :disabled="projectModel.title.length <= 0" @click="validateForm" v-if="!model">Создать</v-btn>
			<v-btn color="blue lighten-1" class="mt-1" :dark="projectModel.title.length > 0" :disabled="projectModel.title.length <= 0" @click="validateForm" v-if="model">Сохранить</v-btn>
		</v-card-actions>
	</v-card>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, minLength, maxLength } from 'vuelidate/lib/validators'

export default {
	name:"ProjectForm",
	mixins: [ validationMixin ],
	props: { model:null },
	validations: {
		projectModel: {
			title: { required, minLength:minLength(3), maxLength:maxLength(100) }
		}
	},
	data: () => ({
		projectModel:null,
		formHeight:188
	}),
	computed: {
		titleInputErrors(){
			const errors = []
			if(!this.$v.projectModel.$dirty) return errors
			!this.$v.projectModel.title.minLength && errors.push('Минимум 3 символа')
			!this.$v.projectModel.title.maxLength && errors.push('Максимум 100 символов')
			!this.$v.projectModel.title.required && errors.push('Обязательное поле')
			return errors
		}
	},
	created(){
		this.projectModel = this.model ? this.model : { title:"", description:"" }
		if(this.model) this.formHeight = 150
	},
	methods: {
		createProject(){
			this.$eventBus.$emit('project_created', this.projectModel)
			this.projectModel = { title:"", description:"" }
		},
		updateProject(){
			this.$eventBus.$emit('project_updated', this.projectModel)
		},
		validateForm(){
			this.$v.$touch()
			if(!this.$v.$invalid){
				if(!this.model){
					this.createProject()
				} else {
					this.updateProject()
				}
				this.$v.projectModel.$reset()
			}
		}
	},
}
</script>

